import type { IntakeSpec } from '@shared/types';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type Q = IntakeSpec['qualityLevel'];

const LEVELS: Array<{ value: Q; isExtreme?: boolean }> = [
  { value: 'draft' },
  { value: 'standard' },
  { value: 'manufacturing' },
  { value: 'extreme', isExtreme: true },
];

export function QualityLevelSection({
  value,
  onChange,
}: {
  value: Q | undefined;
  onChange: (next: Q) => void;
}) {
  const { t } = useTranslation('intake');
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {LEVELS.map((lvl) => {
        const active = lvl.value === value;
        return (
          <button
            key={lvl.value}
            type="button"
            onClick={() => onChange(lvl.value)}
            className={cn(
              'flex flex-col items-start gap-0.5 rounded-xl border px-3 py-2 text-xs transition text-left',
              active
                ? 'border-synergy-blue bg-synergy-blue/10 text-synergy-blue'
                : 'border-synergy-neutral-700/40 bg-white/40 text-synergy-text-tertiary hover:border-synergy-blue/25',
              lvl.isExtreme && !active && 'ring-1 ring-brand-indigo/30',
            )}
          >
            <span className="font-medium">{t(`qualityLevels.${lvl.value}.label`)}</span>
            <span className="text-[10px] text-synergy-text-tertiary/70">{t(`qualityLevels.${lvl.value}.hint`)}</span>
          </button>
        );
      })}
    </div>
  );
}
